import { useEffect, useRef } from 'react'
import './WhoWeAre.css'

const WhoWeAre = () => {
  const sectionRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const section = sectionRef.current
    if (!section) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add('visible')
        } else {
          section.classList.remove('visible')
        }
      },
      { threshold: 0.3 }
    )

    observer.observe(section)
    return () => observer.unobserve(section)
  }, [])

  return (
    <section ref={sectionRef} className="who-we-are-section">
      <div className="who-we-are-text">
        <h2 className="slide-in-1">Who We Are</h2>
        <p className="slide-in-2">
          We are dedicated professionals providing cleaning services to businesses, employees, and environments.
        </p>
        <p className="slide-in-3">
          Our mission is to exceed expectations with attention to detail, efficient processes, and reliable service,
          letting you focus on what matters.
        </p>
        <p className="slide-in-4">
          For high-performance industrial cleaning, trust Adept Services. Contact us today to discuss your facility's needs.
        </p>

        <ul className="who-we-are-list">
          <li>
            <strong>Expert Knowledge</strong>: Delivering exceptional cleaning results.
          </li>
          <li>
            <strong>Quality Assurance</strong>: Ensuring top-tier outcomes.
          </li>
          <li>
            <strong>Health &amp; Safety</strong>: Prioritizing safe, risk-free solutions.
          </li>
          <li>
            <strong>Sustainability</strong>: Leading with eco-friendly practices.
          </li>
          <li>
            <strong>Contract Excellence</strong>: Managing seamless service delivery.
          </li>
        </ul>

        <a href="/contact" className="ctaButton">
          Learn More
        </a>
      </div>

      <div className="who-we-are-svg" aria-hidden="true">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1845 2055"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <pattern id="hexImage" patternUnits="objectBoundingBox" width="1" height="1">
              <image
                xlinkHref="/hero/a_adept.png"
                width="9%"
                height="9%"
                x="4.5%"
                y=".5%"
                preserveAspectRatio="xMidYMid meet"
              />
            </pattern>
          </defs>
          <g transform="matrix(4.16667,0,0,4.16667,0,0)">
            <g className="slide-left">
              <g transform="matrix(2.16316,0,0,-2.16316,216.951,188.455)">
                <path
                  d="M0,-134.541C-8.972,-134.541 -17.331,-129.715 -21.813,-121.946L-46.109,-79.866C-50.594,-72.097 -50.594,-62.445 -46.109,-54.676L-21.813,-12.596C-17.331,-4.827 -8.972,0 0,0L48.591,0C57.563,0 65.921,-4.827 70.404,-12.596L94.7,-54.676C99.187,-62.445 99.187,-72.097 94.702,-79.866L70.404,-121.946C65.921,-129.715 57.563,-134.541 48.591,-134.541L0,-134.541Z"
                  style={{ fill: 'white' }}
                />
              </g>
            </g>

            <g className="slide-top">
              <path
                d="M216.951,188.455L322.062,188.455C342.348,189.352 358.331,197.891 369.247,215.702L421.803,306.728C431.057,323.844 431.934,341.908 421.807,361.218L369.247,452.244C358.773,469.66 342.892,478.499 322.062,479.489L216.951,479.489C196.444,478.793 180.583,469.944 169.766,452.244L117.21,361.218C107.212,342.349 107.781,324.225 117.21,306.728L169.766,215.702C179.857,199.488 194.719,189.309 216.951,188.455"
                style={{ fill: 'url(#hexImage)' }}
              />
            </g>

            <g className="slide-right">
              <g transform="matrix(1.82713,0,0,-1.82713,70.1669,969.515)">
                <g opacity="0.3">
                  <g transform="translate(14.2413,356.288)">
                    <path
                      d="M0,140.859L48.591,140.859C58.719,140.859 68.078,135.456 73.142,126.684L97.437,84.604C102.501,75.833 102.501,65.026 97.437,56.255L73.142,14.174C68.078,5.403 58.719,0 48.591,0L0,0C-10.128,0 -19.487,5.403 -24.551,14.174L-48.846,56.255C-53.91,65.026 -53.91,75.833 -48.846,84.604L-24.551,126.684C-19.487,135.456 -10.128,140.859 0,140.859"
                      style={{ fill: 'rgb(0,137,122)' }}
                    />
                  </g>
                </g>
              </g>
            </g>

            <g className="slide-bottom">
              <g transform="matrix(2.43487,0,0,-2.43487,17.5847,1163.21)">
                <g opacity="0.3">
                  <g transform="translate(105.521,385.025)">
                    <path
                      d="M0,92.706L20.79,92.706C30.917,92.706 40.276,87.303 45.34,78.531L55.735,60.527C60.799,51.756 60.799,40.949 55.735,32.179L45.34,14.174C40.276,5.403 30.917,0 20.79,0L0,0C-10.128,0 -19.487,5.403 -24.551,14.175L-34.945,32.179C-40.009,40.949 -40.009,51.756 -34.945,60.527L-24.551,78.531C-19.487,87.303 -10.128,92.706 0,92.706"
                      style={{ fill: 'rgb(21,183,218)' }}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </section>
  )
}

export default WhoWeAre
